import { faPlus } from '@fortawesome/pro-regular-svg-icons/faPlus'
import { Button, Flex } from '@mantine/core'
import { useRouter } from 'next/router'

import { PaymentType } from '@flecto-io/core/src/interfaces'
import { useAnalytics } from '@flecto/analytics'
import {
  useQueryGetAllBookingProducts,
  useQueryGetBookingById,
} from '@flecto/core/saas'
import { useTranslation } from '@flecto/translations'
import { Icon } from '@flecto/ui'

import { useBookingStatus } from '../../../../../../../shared-ui-modules/@legacy/src/_saas/bookings/BookingItemsModule/shared/state'
import styles from './styles.module.css'

interface IViewPayment {
  canRegisterPayment?: boolean
}

export default function ViewPayments({ canRegisterPayment }: IViewPayment) {
  const { t } = useTranslation('saas', { keyPrefix: 'booking' })
  const router = useRouter()
  const track = useAnalytics('segment')
  const { setRegisterPaymentStep } = useBookingStatus()

  const bookingId = router.query.id ? Number(router.query.id) : ''
  const { data } = useQueryGetBookingById({ bookingId })
  const { data: bookingProducts } = useQueryGetAllBookingProducts({
    bookingId,
  })

  const { status } = data || {}

  return (
    <Flex mt='lg' direction='column'>
      {canRegisterPayment && (
        <Button
          fullWidth
          size={'sm'}
          className={styles.regPagButton}
          disabled={!status || !bookingProducts?.length}
          variant='outline'
          leftSection={<Icon icon={faPlus} />}
          onClick={() => {
            router.push(`/bookings/${bookingId}/?view=payments`)
            track('BOOKING_PAYMENT__REGISTER', {
              booking_id: bookingId,
            })
            setRegisterPaymentStep(PaymentType.payment)
          }}
        >
          {t('create-booking.booking_payments.register_payment')}
        </Button>
      )}
    </Flex>
  )
}
